import { memo, type CSSProperties } from "react";
import { WarningIcon } from "lola-framework-ui-test";
import { useStore } from "../../store/globalState";

interface FirstSendWarningProps {
  title: string;
  body: string;
  className?: string;
}

/** Non-blocking notice. Colors come from the active white view. */
export const FirstSendWarning = memo(
  ({ title, body, className }: FirstSendWarningProps) => {
    const { theme } = useStore();
    const { bodyCopy, dropzoneColors } = theme.whiteView;
    const accent = dropzoneColors[0];

    return (
      <section
        className={className ? `first-send-warning ${className}` : "first-send-warning"}
        role="note"
        style={
          {
            "--first-send-accent": accent,
            "--first-send-title": bodyCopy,
            "--first-send-body": bodyCopy,
          } as CSSProperties
        }
      >
        <WarningIcon size={22} colors={dropzoneColors} />
        <div>
          <p className="first-send-warning-title">{title}</p>
          <p className="first-send-warning-body">{body}</p>
        </div>
      </section>
    );
  }
);
